const state = () => ({
    informations: null,
    connected: false,
    loadingUserInfo: false,
    loadingUserAccessList: false
});

const getters = {
    getUserInformations: state => {
        return state.informations;
    },
    getConnectedState: state => {
        return state.connected;
    },
    getLoadingUserInfo: state => {
        return state.loadingUserInfo;
    },
    getLoadingUserAccessList: state => {
        return state.loadingUserAccessList;
    }
};

const mutations = {
    setUserInformations(state, informations) {
        state.informations = informations;
    },
    setConnectedState(state, connected) {
        state.connected = connected;
    },
    setLoadingUserInfo(state, loading) {
        state.loadingUserInfo = loading;
    },
    setLoadingUserAccessList(state, loading) {
        state.loadingUserAccessList = loading;
    },
    setUserInfo(state, userInfo) {
        state.informations = {
            ...(state.informations || {}),
            userInfo
        };
    },
    setUserAccessList(state, userAccessList) {
        state.informations = {
            ...(state.informations || {}),
            userAccessList
        };
    }
};

const actions = {};

export default {
    state,
    getters,
    actions,
    mutations
};
